import React, { useEffect } from "react";
import { useLogout } from "hooks/useLogout";
import { useNavigation } from "@react-navigation/native";

const Logout = () => {
  const { logoutAccount } = useLogout();
  const navigation = useNavigation();
  useEffect(() => {
    navigation.navigate("AuthenticatedFlow", { screen: "LogOut" });
    logoutAccount();
  }, []);

  return null;
};

export default Logout;
